import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const { isFeatureEnabled } = useFeatureFlags();
  
  if (!isFeatureEnabled('languageSwitcher') || !isFeatureEnabled('multiLanguage')) {
    return null;
  }

  const currentLanguage = i18n.language;
  
  const languages = [
    { code: 'en', name: 'EN', flag: '🇺🇸' },
    { code: 'pt', name: 'PT', flag: '🇧🇷' }
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      {languages.map((language) => (
        <motion.button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          className={`
            px-3 py-1.5 rounded-md text-sm font-medium transition-smooth flex items-center space-x-1
            ${currentLanguage === language.code 
              ? 'bg-accent text-accent-foreground' 
              : 'text-text-secondary hover:text-accent hover:bg-muted'
            }
          `}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="text-xs">{language.flag}</span>
          <span>{language.name}</span>
        </motion.button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;